import React, {useContext, useRef} from 'react';
import { useGSAP } from '@gsap/react';
import Context from '../OriginStoryProvider';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap';

const Header = () => {
	const { data: {content} } = useContext(Context);
	
	const headerContainer = useRef(null);
	const headlineQuoteText = useRef(null);
	const pinnedEl = useRef(null);

	useGSAP(() => {
		const split = new SplitText(headlineQuoteText.current, { type: 'chars, words', wordsClass: 'word' });

		const tl = gsap.timeline()
			.to('.chapter-3__headline-quote--1__quote', {
				'--lquo-opacity': 1,
			})
			.from(split.chars, {
				opacity: 0,
				rotate: (i) => -i * 0.1,
				y: (i) => -i * 0.1,
				skewY: -5,
				stagger: 0.1,
			})
			.from('.chapter-3__headline-quote--1__citation', {
				opacity: 0,
			})
			.to('.chapter-3__header__pinned-el .main-grid__body', {
				y: '-100vh',
				delay: 1,
				duration: 1.5
			})
			.to('.chapter-3__header__pinned-el__bg-color', {
				opacity: 0,
			}, '<')
			.to({}, {duration: 1})

		ScrollTrigger.create({
			trigger: pinnedEl.current,
			start: 'top top',
			end: () => 'bottom+=400%',
			pin: true,
			scrub: 2,
			animation: tl,
		});

	}, {scope: headerContainer.current, dependencies: [content.chapters]});

	return (
		<header className='chapter-3__header__container' ref={headerContainer}>
			<div className='chapter-3__header__wrapper main-grid'>
				<div className='main-grid__margin'></div>
				<div className='main-grid__body'>
					<div className='chapter-3__title-container'>
						<p className='chapter-3__label label-text'>{content.chapters.third.label}</p>
						<h2 className='chapter-3__title'>{content.chapters.third.title}</h2>
					</div>
				</div>
				<div className='main-grid__margin'></div>
			</div>
			<div className='chapter-3__header__pinned-el' ref={pinnedEl}>
				<img className='chapter-3__header__pinned-el__bg-img' src={`${mainScript.assetPath}images/jpg/chapter-3/carnegie-library-cornerstone-1907.jpg`}/>
				<div className='chapter-3__header__pinned-el__bg-color'></div>
				<div className='main-grid'>
					<div className='main-grid__margin'></div>
					<div className='main-grid__body'>
						<p className='chapter-3__headline-quote--1__quote headline-quote' ref={headlineQuoteText}>{content.chapters.third.header.quote}&rdquo;</p>
						<cite 
							className='chapter-3__headline-quote--1__citation quote-attribute'
							dangerouslySetInnerHTML={{__html: content.chapters.third.header.attribution}}
						></cite>
					</div>
					<div className='main-grid__margin'></div>
				</div>
			</div>
			<p className='chapter-3__header__img-caption img-caption'>{content.chapters.third.header.img_caption}</p>
		</header>
	)
}

export default Header;